import RestApiModel from "@/api/Model/RestApiModel";

class ContentManagement extends RestApiModel {
  static getResourceEndpoint() {
    return '/content-management/administrators';
  }
}

export default ContentManagement;
